import stubDarkImage from 'img/fileFolderHistoryLog/stub-dark.png';
import stubLightImage from 'img/fileFolderHistoryLog/stub-light.png';
import { isDarkThemeModeEnabled } from 'reactApp/utils/theme';

export const useStubImage = () => {
    const isDarkTheme = isDarkThemeModeEnabled();
    const stubImage = isDarkTheme ? stubDarkImage : stubLightImage;
    return { stubImage };
};
